// extracted by mini-css-extract-plugin
export var gif = "_ha-0";